module.exports = __webpack_public_path__ + "static/media/ADA.24157d4e.svg";